// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/ZabalDEMO-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/ZabalDEMO-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/ZabalDEMO-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	letter-spacing: 0.25px;
	background: #fff;
	-ms-overflow-style: none;
	font-family: "ZabalRegular";
}

a {
	text-decoration: none;
}

.MuiInputBase-root,
.MuiOutlinedInput-root,
.MuiInputBase-colorPrimary,
.MuiInputBase-fullWidth,
.MuiInputBase-formControl,
.MuiInputBase-adornedEnd,
.MuiAutocomplete-inputRoot,
.css-ct26vv-MuiInputBase-root-MuiOutlinedInput-root {
	border-radius: 8px !important;
}

.swiper {
	border-radius: 12px;
}

input {
	font-size: 16px;
}
input::placeholder {
	font-size: 14px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
input[type="number"] {
	appearance: textfield;
	-moz-appearance: textfield;
}

/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after {
	--tw-border-spacing-x: 0;
	--tw-border-spacing-y: 0;
	--tw-translate-x: 0;
	--tw-translate-y: 0;
	--tw-rotate: 0;
	--tw-skew-x: 0;
	--tw-skew-y: 0;
	--tw-scale-x: 1;
	--tw-scale-y: 1;
	--tw-pan-x:  ;
	--tw-pan-y:  ;
	--tw-pinch-zoom:  ;
	--tw-scroll-snap-strictness: proximity;
	--tw-gradient-from-position:  ;
	--tw-gradient-via-position:  ;
	--tw-gradient-to-position:  ;
	--tw-ordinal:  ;
	--tw-slashed-zero:  ;
	--tw-numeric-figure:  ;
	--tw-numeric-spacing:  ;
	--tw-numeric-fraction:  ;
	--tw-ring-inset:  ;
	--tw-ring-offset-width: 0px;
	--tw-ring-offset-color: #fff;
	--tw-ring-color: rgb(59 130 246 / 0.5);
	--tw-ring-offset-shadow: 0 0 #0000;
	--tw-ring-shadow: 0 0 #0000;
	--tw-shadow: 0 0 #0000;
	--tw-shadow-colored: 0 0 #0000;
	--tw-blur:  ;
	--tw-brightness:  ;
	--tw-contrast:  ;
	--tw-grayscale:  ;
	--tw-hue-rotate:  ;
	--tw-invert:  ;
	--tw-saturate:  ;
	--tw-sepia:  ;
	--tw-drop-shadow:  ;
	--tw-backdrop-blur:  ;
	--tw-backdrop-brightness:  ;
	--tw-backdrop-contrast:  ;
	--tw-backdrop-grayscale:  ;
	--tw-backdrop-hue-rotate:  ;
	--tw-backdrop-invert:  ;
	--tw-backdrop-opacity:  ;
	--tw-backdrop-saturate:  ;
	--tw-backdrop-sepia:  ;
}

::backdrop {
	--tw-border-spacing-x: 0;
	--tw-border-spacing-y: 0;
	--tw-translate-x: 0;
	--tw-translate-y: 0;
	--tw-rotate: 0;
	--tw-skew-x: 0;
	--tw-skew-y: 0;
	--tw-scale-x: 1;
	--tw-scale-y: 1;
	--tw-pan-x:  ;
	--tw-pan-y:  ;
	--tw-pinch-zoom:  ;
	--tw-scroll-snap-strictness: proximity;
	--tw-gradient-from-position:  ;
	--tw-gradient-via-position:  ;
	--tw-gradient-to-position:  ;
	--tw-ordinal:  ;
	--tw-slashed-zero:  ;
	--tw-numeric-figure:  ;
	--tw-numeric-spacing:  ;
	--tw-numeric-fraction:  ;
	--tw-ring-inset:  ;
	--tw-ring-offset-width: 0px;
	--tw-ring-offset-color: #fff;
	--tw-ring-color: rgb(59 130 246 / 0.5);
	--tw-ring-offset-shadow: 0 0 #0000;
	--tw-ring-shadow: 0 0 #0000;
	--tw-shadow: 0 0 #0000;
	--tw-shadow-colored: 0 0 #0000;
	--tw-blur:  ;
	--tw-brightness:  ;
	--tw-contrast:  ;
	--tw-grayscale:  ;
	--tw-hue-rotate:  ;
	--tw-invert:  ;
	--tw-saturate:  ;
	--tw-sepia:  ;
	--tw-drop-shadow:  ;
	--tw-backdrop-blur:  ;
	--tw-backdrop-brightness:  ;
	--tw-backdrop-contrast:  ;
	--tw-backdrop-grayscale:  ;
	--tw-backdrop-hue-rotate:  ;
	--tw-backdrop-invert:  ;
	--tw-backdrop-opacity:  ;
	--tw-backdrop-saturate:  ;
	--tw-backdrop-sepia:  ;
}
.invisible {
	visibility: hidden;
}
.fixed {
	position: fixed;
}
.absolute {
	position: absolute;
}
.relative {
	position: relative;
}
.inset-0 {
	inset: 0px;
}
.-left-\\[70px\\] {
	left: -70px;
}
.-top-1 {
	top: -0.25rem;
}
.-top-1\\.5 {
	top: -0.375rem;
}
.bottom-2 {
	bottom: 0.5rem;
}
.bottom-2\\.5 {
	bottom: 0.625rem;
}
.bottom-\\[120\\%\\] {
	bottom: 120%;
}
.left-0 {
	left: 0px;
}
.left-3 {
	left: 0.75rem;
}
.right-0 {
	right: 0px;
}
.right-1 {
	right: 0.25rem;
}
.right-1\\.5 {
	right: 0.375rem;
}
.right-10 {
	right: 2.5rem;
}
.right-2 {
	right: 0.5rem;
}
.right-2\\.5 {
	right: 0.625rem;
}
.right-3 {
	right: 0.75rem;
}
.right-4 {
	right: 1rem;
}
.right-\\[15px\\] {
	right: 15px;
}
.right-\\[25px\\] {
	right: 25px;
}
.top-0 {
	top: 0px;
}
.top-0\\.5 {
	top: 0.125rem;
}
.top-10 {
	top: 2.5rem;
}
.top-2 {
	top: 0.5rem;
}
.top-2\\.5 {
	top: 0.625rem;
}
.top-3 {
	top: 0.75rem;
}
.top-\\[10px\\] {
	top: 10px;
}
.top-\\[13px\\] {
	top: 13px;
}
.top-\\[15px\\] {
	top: 15px;
}
.top-\\[18px\\] {
	top: 18px;
}
.top-\\[25px\\] {
	top: 25px;
}
.top-\\[27px\\] {
	top: 27px;
}
.top-\\[40px\\] {
	top: 40px;
}
.top-\\[48px\\] {
	top: 48px;
}
.top-\\[55px\\] {
	top: 55px;
}
.top-\\[70px\\] {
	top: 70px;
}
.z-10 {
	z-index: 10;
}
.z-20 {
	z-index: 20;
}
.z-\\[10\\] {
	z-index: 10;
}
.z-\\[11\\] {
	z-index: 11;
}
.z-\\[12\\] {
	z-index: 12;
}
.z-\\[13\\] {
	z-index: 13;
}
.z-\\[1\\] {
	z-index: 1;
}
.z-\\[2\\] {
	z-index: 2;
}
.z-\\[3\\] {
	z-index: 3;
}
.z-\\[4\\] {
	z-index: 4;
}
.z-\\[5\\] {
	z-index: 5;
}
.z-\\[6\\] {
	z-index: 6;
}
.col-span-1 {
	grid-column: span 1 / span 1;
}
.col-span-2 {
	grid-column: span 2 / span 2;
}
.mx-4 {
	margin-left: 1rem;
	margin-right: 1rem;
}
.mx-auto {
	margin-left: auto;
	margin-right: auto;
}
.my-10 {
	margin-top: 2.5rem;
	margin-bottom: 2.5rem;
}
.my-3 {
	margin-top: 0.75rem;
	margin-bottom: 0.75rem;
}
.my-4 {
	margin-top: 1rem;
	margin-bottom: 1rem;
}
.my-5 {
	margin-top: 1.25rem;
	margin-bottom: 1.25rem;
}
.my-6 {
	margin-top: 1.5rem;
	margin-bottom: 1.5rem;
}
.my-8 {
	margin-top: 2rem;
	margin-bottom: 2rem;
}
.\\!mt-0 {
	margin-top: 0px !important;
}
.\\!mt-7 {
	margin-top: 1.75rem !important;
}
.-mb-1 {
	margin-bottom: -0.25rem;
}
.-mb-5 {
	margin-bottom: -1.25rem;
}
.-mt-0 {
	margin-top: -0px;
}
.-mt-0\\.5 {
	margin-top: -0.125rem;
}
.-mt-1 {
	margin-top: -0.25rem;
}
.-mt-4 {
	margin-top: -1rem;
}
.-mt-5 {
	margin-top: -1.25rem;
}
.-mt-6 {
	margin-top: -1.5rem;
}
.mb-0 {
	margin-bottom: 0px;
}
.mb-1 {
	margin-bottom: 0.25rem;
}
.mb-1\\.5 {
	margin-bottom: 0.375rem;
}
.mb-10 {
	margin-bottom: 2.5rem;
}
.mb-2 {
	margin-bottom: 0.5rem;
}
.mb-2\\.5 {
	margin-bottom: 0.625rem;
}
.mb-3 {
	margin-bottom: 0.75rem;
}
.mb-4 {
	margin-bottom: 1rem;
}
.mb-5 {
	margin-bottom: 1.25rem;
}
.mb-6 {
	margin-bottom: 1.5rem;
}
.mb-7 {
	margin-bottom: 1.75rem;
}
.mb-8 {
	margin-bottom: 2rem;
}
.ml-2 {
	margin-left: 0.5rem;
}
.ml-2\\.5 {
	margin-left: 0.625rem;
}
.ml-4 {
	margin-left: 1rem;
}
.mr-2 {
	margin-right: 0.5rem;
}
.mt-1 {
	margin-top: 0.25rem;
}
.mt-10 {
	margin-top: 2.5rem;
}
.mt-2 {
	margin-top: 0.5rem;
}
.mt-2\\.5 {
	margin-top: 0.625rem;
}
.mt-3 {
	margin-top: 0.75rem;
}
.mt-3\\.5 {
	margin-top: 0.875rem;
}
.mt-4 {
	margin-top: 1rem;
}
.mt-5 {
	margin-top: 1.25rem;
}
.mt-6 {
	margin-top: 1.5rem;
}
.mt-8 {
	margin-top: 2rem;
}
.mt-\\[0\\.1px\\] {
	margin-top: 0.1px;
}
.mt-\\[25px\\] {
	margin-top: 25px;
}
.mt-\\[45px\\] {
	margin-top: 45px;
}
.mt-\\[50px\\] {
	margin-top: 50px;
}
.mt-\\[60px\\] {
	margin-top: 60px;
}
.block {
	display: block;
}
.inline-block {
	display: inline-block;
}
.inline {
	display: inline;
}
.flex {
	display: flex;
}
.inline-flex {
	display: inline-flex;
}
.table {
	display: table;
}
.grid {
	display: grid;
}
.hidden {
	display: none;
}
.\\!h-\\[44px\\] {
	height: 44px !important;
}
.\\!h-\\[45px\\] {
	height: 45px !important;
}
.\\!h-full {
	height: 100% !important;
}
.h-1 {
	height: 0.25rem;
}
.h-1\\.5 {
	height: 0.375rem;
}
.h-10 {
	height: 2.5rem;
}
.h-2 {
	height: 0.5rem;
}
.h-2\\.5 {
	height: 0.625rem;
}
.h-3 {
	height: 0.75rem;
}
.h-3\\.5 {
	height: 0.875rem;
}
.h-\\[105px\\] {
	height: 105px;
}
.h-\\[110px\\] {
	height: 110px;
}
.h-\\[120px\\] {
	height: 120px;
}
.h-\\[140px\\] {
	height: 140px;
}
.h-\\[15\\.5px\\] {
	height: 15.5px;
}
.h-\\[16px\\] {
	height: 16px;
}
.h-\\[17px\\] {
	height: 17px;
}
.h-\\[18px\\] {
	height: 18px;
}
.h-\\[19px\\] {
	height: 19px;
}
.h-\\[1px\\] {
	height: 1px;
}
.h-\\[200px\\] {
	height: 200px;
}
.h-\\[20px\\] {
	height: 20px;
}
.h-\\[21px\\] {
	height: 21px;
}
.h-\\[22px\\] {
	height: 22px;
}
.h-\\[250px\\] {
	height: 250px;
}
.h-\\[25px\\] {
	height: 25px;
}
.h-\\[270px\\] {
	height: 270px;
}
.h-\\[27px\\] {
	height: 27px;
}
.h-\\[28px\\] {
	height: 28px;
}
.h-\\[300px\\] {
	height: 300px;
}
.h-\\[30px\\] {
	height: 30px;
}
.h-\\[320px\\] {
	height: 320px;
}
.h-\\[32px\\] {
	height: 32px;
}
.h-\\[33px\\] {
	height: 33px;
}
.h-\\[340px\\] {
	height: 340px;
}
.h-\\[34px\\] {
	height: 34px;
}
.h-\\[350px\\] {
	height: 350px;
}
.h-\\[35px\\] {
	height: 35px;
}
.h-\\[370px\\] {
	height: 370px;
}
.h-\\[40\\.75px\\] {
	height: 40.75px;
}
.h-\\[400px\\] {
	height: 400px;
}
.h-\\[40px\\] {
	height: 40px;
}
.h-\\[41px\\] {
	height: 41px;
}
.h-\\[42px\\] {
	height: 42px;
}
.h-\\[43px\\] {
	height: 43px;
}
.h-\\[44px\\] {
	height: 44px;
}
.h-\\[45px\\] {
	height: 45px;
}
.h-\\[47px\\] {
	height: 47px;
}
.h-\\[50px\\] {
	height: 50px;
}
.h-\\[55px\\] {
	height: 55px;
}
.h-\\[57vh\\] {
	height: 57vh;
}
.h-\\[60px\\] {
	height: 60px;
}
.h-\\[70px\\] {
	height: 70px;
}
.h-\\[75px\\] {
	height: 75px;
}
.h-\\[78vh\\] {
	height: 78vh;
}
.h-\\[80px\\] {
	height: 80px;
}
.h-\\[80vh\\] {
	height: 80vh;
}
.h-\\[82\\%\\] {
	height: 82%;
}
.h-\\[82px\\] {
	height: 82px;
}
.h-\\[82vh\\] {
	height: 82vh;
}
.h-\\[85vh\\] {
	height: 85vh;
}
.h-\\[87\\%\\] {
	height: 87%;
}
.h-\\[89\\%\\] {
	height: 89%;
}
.h-\\[lvh\\] {
	height: lvh;
}
.h-auto {
	height: auto;
}
.h-full {
	height: 100%;
}
.h-screen {
	height: 100vh;
}
.max-h-\\[105px\\] {
	max-height: 105px;
}
.max-h-\\[110px\\] {
	max-height: 110px;
}
.max-h-\\[120px\\] {
	max-height: 120px;
}
.max-h-\\[200px\\] {
	max-height: 200px;
}
.max-h-\\[220px\\] {
	max-height: 220px;
}
.max-h-\\[230px\\] {
	max-height: 230px;
}
.max-h-\\[300px\\] {
	max-height: 300px;
}
.max-h-\\[320px\\] {
	max-height: 320px;
}
.max-h-\\[400px\\] {
	max-height: 400px;
}
.max-h-\\[450px\\] {
	max-height: 450px;
}
.max-h-\\[500px\\] {
	max-height: 500px;
}
.max-h-\\[550px\\] {
	max-height: 550px;
}
.max-h-\\[700px\\] {
	max-height: 700px;
}
.min-h-\\[115px\\] {
	min-height: 115px;
}
.min-h-\\[120px\\] {
	min-height: 120px;
}
.min-h-\\[130px\\] {
	min-height: 130px;
}
.min-h-\\[155px\\] {
	min-height: 155px;
}
.min-h-\\[30px\\] {
	min-height: 30px;
}
.min-h-\\[40px\\] {
	min-height: 40px;
}
.\\!w-1\\/3 {
	width: 33.333333% !important;
}
.\\!w-2\\/3 {
	width: 66.666667% !important;
}
.\\!w-2\\/4 {
	width: 50% !important;
}
.\\!w-5\\/6 {
	width: 83.333333% !important;
}
.\\!w-\\[100px\\] {
	width: 100px !important;
}
.\\!w-\\[110px\\] {
	width: 110px !important;
}
.\\!w-\\[140px\\] {
	width: 140px !important;
}
.\\!w-\\[45px\\] {
	width: 45px !important;
}
.\\!w-\\[50px\\] {
	width: 50px !important;
}
.\\!w-\\[75px\\] {
	width: 75px !important;
}
.\\!w-full {
	width: 100% !important;
}
.w-1 {
	width: 0.25rem;
}
.w-1\\.5 {
	width: 0.375rem;
}
.w-1\\/2 {
	width: 50%;
}
.w-10 {
	width: 2.5rem;
}
.w-10\\/12 {
	width: 83.333333%;
}
.w-11\\/12 {
	width: 91.666667%;
}
.w-2 {
	width: 0.5rem;
}
.w-2\\.5 {
	width: 0.625rem;
}
.w-2\\/3 {
	width: 66.666667%;
}
.w-3\\/5 {
	width: 60%;
}
.w-4\\/6 {
	width: 66.666667%;
}
.w-5\\/6 {
	width: 83.333333%;
}
.w-9\\/12 {
	width: 75%;
}
.w-\\[10\\/12\\] {
	width: 10/12;
}
.w-\\[100vw\\] {
	width: 100vw;
}
.w-\\[105px\\] {
	width: 105px;
}
.w-\\[130px\\] {
	width: 130px;
}
.w-\\[140px\\] {
	width: 140px;
}
.w-\\[145px\\] {
	width: 145px;
}
.w-\\[14px\\] {
	width: 14px;
}
.w-\\[150px\\] {
	width: 150px;
}
.w-\\[160px\\] {
	width: 160px;
}
.w-\\[170px\\] {
	width: 170px;
}
.w-\\[25px\\] {
	width: 25px;
}
.w-\\[27px\\] {
	width: 27px;
}
.w-\\[28px\\] {
	width: 28px;
}
.w-\\[2px\\] {
	width: 2px;
}
.w-\\[300px\\] {
	width: 300px;
}
.w-\\[30px\\] {
	width: 30px;
}
.w-\\[32px\\] {
	width: 32px;
}
.w-\\[34px\\] {
	width: 34px;
}
.w-\\[40px\\] {
	width: 40px;
}
.w-\\[42px\\] {
	width: 42px;
}
.w-\\[48\\%\\] {
	width: 48%;
}
.w-\\[52\\%\\] {
	width: 52%;
}
.w-\\[55px\\] {
	width: 55px;
}
.w-\\[56px\\] {
	width: 56px;
}
.w-\\[60px\\] {
	width: 60px;
}
.w-\\[65\\%\\] {
	width: 65%;
}
.w-\\[80px\\] {
	width: 80px;
}
.w-\\[83\\%\\] {
	width: 83%;
}
.w-\\[85\\%\\] {
	width: 85%;
}
.w-\\[86\\%\\] {
	width: 86%;
}
.w-\\[88\\%\\] {
	width: 88%;
}
.w-\\[90\\%\\] {
	width: 90%;
}
.w-\\[90px\\] {
	width: 90px;
}
.w-\\[92px\\] {
	width: 92px;
}
.w-\\[calc\\(100\\%-32px\\)\\] {
	width: calc(100% - 32px);
}
.w-\\[calc\\(100\\%-92px\\)\\] {
	width: calc(100% - 92px);
}
.w-auto {
	width: auto;
}
.w-full {
	width: 100%;
}
.min-w-\\[340px\\] {
	min-width: 340px;
}
.min-w-\\[450px\\] {
	min-width: 450px;
}
.min-w-\\[600px\\] {
	min-width: 600px;
}
.min-w-\\[700px\\] {
	min-width: 700px;
}
.min-w-\\[900px\\] {
	min-width: 900px;
}
.\\!max-w-\\[200px\\] {
	max-width: 200px !important;
}
.max-w-\\[110px\\] {
	max-width: 110px;
}
.max-w-\\[115px\\] {
	max-width: 115px;
}
.max-w-\\[120px\\] {
	max-width: 120px;
}
.max-w-\\[125px\\] {
	max-width: 125px;
}
.max-w-\\[135px\\] {
	max-width: 135px;
}
.max-w-\\[1400x\\] {
	max-width: 1400x;
}
.max-w-\\[1440px\\] {
	max-width: 1440px;
}
.max-w-\\[150px\\] {
	max-width: 150px;
}
.max-w-\\[160px\\] {
	max-width: 160px;
}
.max-w-\\[175px\\] {
	max-width: 175px;
}
.max-w-\\[180px\\] {
	max-width: 180px;
}
.max-w-\\[200px\\] {
	max-width: 200px;
}
.max-w-\\[210px\\] {
	max-width: 210px;
}
.max-w-\\[220px\\] {
	max-width: 220px;
}
.max-w-\\[250px\\] {
	max-width: 250px;
}
.max-w-\\[271px\\] {
	max-width: 271px;
}
.max-w-\\[273px\\] {
	max-width: 273px;
}
.max-w-\\[280px\\] {
	max-width: 280px;
}
.max-w-\\[292px\\] {
	max-width: 292px;
}
.max-w-\\[300px\\] {
	max-width: 300px;
}
.max-w-\\[320px\\] {
	max-width: 320px;
}
.max-w-\\[340px\\] {
	max-width: 340px;
}
.max-w-\\[350px\\] {
	max-width: 350px;
}
.max-w-\\[370px\\] {
	max-width: 370px;
}
.max-w-\\[400px\\] {
	max-width: 400px;
}
.max-w-\\[420px\\] {
	max-width: 420px;
}
.max-w-\\[450px\\] {
	max-width: 450px;
}
.max-w-\\[500px\\] {
	max-width: 500px;
}
.max-w-\\[520px\\] {
	max-width: 520px;
}
.max-w-\\[600px\\] {
	max-width: 600px;
}
.shrink {
	flex-shrink: 1;
}
.flex-grow {
	flex-grow: 1;
}
.grow {
	flex-grow: 1;
}
.transform {
	transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-auto {
	cursor: auto;
}
.cursor-default {
	cursor: default;
}
.cursor-pointer {
	cursor: pointer;
}
.resize {
	resize: both;
}
.list-decimal {
	list-style-type: decimal;
}
.list-disc {
	list-style-type: disc;
}
.grid-cols-2 {
	grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
	grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5 {
	grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7 {
	grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row {
	flex-direction: row;
}
.flex-col {
	flex-direction: column;
}
.flex-wrap {
	flex-wrap: wrap;
}
.place-items-center {
	place-items: center;
}
.items-start {
	align-items: flex-start;
}
.items-end {
	align-items: flex-end;
}
.items-center {
	align-items: center;
}
.justify-start {
	justify-content: flex-start;
}
.justify-end {
	justify-content: flex-end;
}
.justify-center {
	justify-content: center;
}
.justify-between {
	justify-content: space-between;
}
.justify-items-end {
	justify-items: end;
}
.gap-0 {
	gap: 0px;
}
.gap-0\\.5 {
	gap: 0.125rem;
}
.gap-1 {
	gap: 0.25rem;
}
.gap-1\\.5 {
	gap: 0.375rem;
}
.gap-10 {
	gap: 2.5rem;
}
.gap-12 {
	gap: 3rem;
}
.gap-14 {
	gap: 3.5rem;
}
.gap-2 {
	gap: 0.5rem;
}
.gap-2\\.5 {
	gap: 0.625rem;
}
.gap-3 {
	gap: 0.75rem;
}
.gap-3\\.5 {
	gap: 0.875rem;
}
.gap-4 {
	gap: 1rem;
}
.gap-5 {
	gap: 1.25rem;
}
.gap-6 {
	gap: 1.5rem;
}
.gap-7 {
	gap: 1.75rem;
}
.gap-8 {
	gap: 2rem;
}
.gap-x-3 {
	column-gap: 0.75rem;
}
.gap-x-4 {
	column-gap: 1rem;
}
.gap-x-6 {
	column-gap: 1.5rem;
}
.gap-y-1 {
	row-gap: 0.25rem;
}
.gap-y-2 {
	row-gap: 0.5rem;
}
.gap-y-3 {
	row-gap: 0.75rem;
}
.gap-y-4 {
	row-gap: 1rem;
}
.gap-y-5 {
	row-gap: 1.25rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(0.25rem * var(--tw-space-x-reverse));
	margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(0.375rem * var(--tw-space-x-reverse));
	margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
	--tw-divide-y-reverse: 0;
	border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
	border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#EEF2F3\\] > :not([hidden]) ~ :not([hidden]) {
	--tw-divide-opacity: 1;
	border-color: rgb(238 242 243 / var(--tw-divide-opacity));
}
.self-start {
	align-self: flex-start;
}
.self-end {
	align-self: flex-end;
}
.self-center {
	align-self: center;
}
.justify-self-end {
	justify-self: end;
}
.justify-self-center {
	justify-self: center;
}
.overflow-auto {
	overflow: auto;
}
.overflow-hidden {
	overflow: hidden;
}
.overflow-x-auto {
	overflow-x: auto;
}
.overflow-y-auto {
	overflow-y: auto;
}
.overflow-y-scroll {
	overflow-y: scroll;
}
.truncate {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.whitespace-pre {
	white-space: pre;
}
.break-normal {
	overflow-wrap: normal;
	word-break: normal;
}
.\\!rounded-full {
	border-radius: 9999px !important;
}
.rounded {
	border-radius: 0.25rem;
}
.rounded-2xl {
	border-radius: 1rem;
}
.rounded-3xl {
	border-radius: 1.5rem;
}
.rounded-\\[30px\\] {
	border-radius: 30px;
}
.rounded-\\[5px\\] {
	border-radius: 5px;
}
.rounded-full {
	border-radius: 9999px;
}
.rounded-lg {
	border-radius: 0.5rem;
}
.rounded-md {
	border-radius: 0.375rem;
}
.rounded-sm {
	border-radius: 0.125rem;
}
.rounded-xl {
	border-radius: 0.75rem;
}
.rounded-l {
	border-top-left-radius: 0.25rem;
	border-bottom-left-radius: 0.25rem;
}
.border {
	border-width: 1px;
}
.border-2 {
	border-width: 2px;
}
.border-y {
	border-top-width: 1px;
	border-bottom-width: 1px;
}
.border-b {
	border-bottom-width: 1px;
}
.border-b-2 {
	border-bottom-width: 2px;
}
.border-l {
	border-left-width: 1px;
}
.border-r {
	border-right-width: 1px;
}
.\\!border-\\[\\#96A0A5\\] {
	--tw-border-opacity: 1 !important;
	border-color: rgb(150 160 165 / var(--tw-border-opacity)) !important;
}
.\\!border-\\[\\#B8B8B880\\] {
	border-color: #B8B8B880 !important;
}
.\\!border-\\[\\#B8B8B8\\] {
	--tw-border-opacity: 1 !important;
	border-color: rgb(184 184 184 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#2B5B6D\\] {
	--tw-border-opacity: 1;
	border-color: rgb(43 91 109 / var(--tw-border-opacity));
}
.border-\\[\\#393F42\\] {
	--tw-border-opacity: 1;
	border-color: rgb(57 63 66 / var(--tw-border-opacity));
}
.border-\\[\\#557C8A\\] {
	--tw-border-opacity: 1;
	border-color: rgb(85 124 138 / var(--tw-border-opacity));
}
.border-\\[\\#717E83\\] {
	--tw-border-opacity: 1;
	border-color: rgb(113 126 131 / var(--tw-border-opacity));
}
.border-\\[\\#879094\\] {
	--tw-border-opacity: 1;
	border-color: rgb(135 144 148 / var(--tw-border-opacity));
}
.border-\\[\\#96A0A5\\] {
	--tw-border-opacity: 1;
	border-color: rgb(150 160 165 / var(--tw-border-opacity));
}
.border-\\[\\#A8A8A8\\] {
	--tw-border-opacity: 1;
	border-color: rgb(168 168 168 / var(--tw-border-opacity));
}
.border-\\[\\#AABDC5\\] {
	--tw-border-opacity: 1;
	border-color: rgb(170 189 197 / var(--tw-border-opacity));
}
.border-\\[\\#ADB8BC\\] {
	--tw-border-opacity: 1;
	border-color: rgb(173 184 188 / var(--tw-border-opacity));
}
.border-\\[\\#B8B8B8\\] {
	--tw-border-opacity: 1;
	border-color: rgb(184 184 184 / var(--tw-border-opacity));
}
.border-\\[\\#B8C8CF\\] {
	--tw-border-opacity: 1;
	border-color: rgb(184 200 207 / var(--tw-border-opacity));
}
.border-\\[\\#BCD2D5\\] {
	--tw-border-opacity: 1;
	border-color: rgb(188 210 213 / var(--tw-border-opacity));
}
.border-\\[\\#C6D3D8\\] {
	--tw-border-opacity: 1;
	border-color: rgb(198 211 216 / var(--tw-border-opacity));
}
.border-\\[\\#D4DEE2\\] {
	--tw-border-opacity: 1;
	border-color: rgb(212 222 226 / var(--tw-border-opacity));
}
.border-\\[\\#D5DEE2\\] {
	--tw-border-opacity: 1;
	border-color: rgb(213 222 226 / var(--tw-border-opacity));
}
.border-\\[\\#E3E9EC\\] {
	--tw-border-opacity: 1;
	border-color: rgb(227 233 236 / var(--tw-border-opacity));
}
.border-\\[\\#EB948121\\] {
	border-color: #EB948121;
}
.border-\\[\\#EEF2F3\\] {
	--tw-border-opacity: 1;
	border-color: rgb(238 242 243 / var(--tw-border-opacity));
}
.border-\\[\\#F6F7F8\\] {
	--tw-border-opacity: 1;
	border-color: rgb(246 247 248 / var(--tw-border-opacity));
}
.border-\\[\\#b8b8b8\\] {
	--tw-border-opacity: 1;
	border-color: rgb(184 184 184 / var(--tw-border-opacity));
}
.border-blue-600 {
	--tw-border-opacity: 1;
	border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.border-fortcore-green {
	--tw-border-opacity: 1;
	border-color: rgb(0 82 93 / var(--tw-border-opacity));
}
.border-fortcore-green\\/50 {
	border-color: rgb(0 82 93 / 0.5);
}
.border-gray-300 {
	--tw-border-opacity: 1;
	border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-primary-color {
	--tw-border-opacity: 1;
	border-color: rgb(0 58 80 / var(--tw-border-opacity));
}
.border-red-500 {
	--tw-border-opacity: 1;
	border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-transparent {
	border-color: transparent;
}
.\\!bg-\\[\\#B8B8B880\\] {
	background-color: #B8B8B880 !important;
}
.\\!bg-transparent {
	background-color: transparent !important;
}
.bg-\\[\\#393F4266\\] {
	background-color: #393F4266;
}
.bg-\\[\\#393F4285\\] {
	background-color: #393F4285;
}
.bg-\\[\\#557C8A\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(85 124 138 / var(--tw-bg-opacity));
}
.bg-\\[\\#8888881F\\] {
	background-color: #8888881F;
}
.bg-\\[\\#8E9DA4\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(142 157 164 / var(--tw-bg-opacity));
}
.bg-\\[\\#B8C8CF\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(184 200 207 / var(--tw-bg-opacity));
}
.bg-\\[\\#BDBDBD66\\] {
	background-color: #BDBDBD66;
}
.bg-\\[\\#C6D3D8\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(198 211 216 / var(--tw-bg-opacity));
}
.bg-\\[\\#D3E5E780\\] {
	background-color: #D3E5E780;
}
.bg-\\[\\#E3E9EC\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(227 233 236 / var(--tw-bg-opacity));
}
.bg-\\[\\#EEF2F3\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(238 242 243 / var(--tw-bg-opacity));
}
.bg-\\[\\#EFF8F9\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(239 248 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#F5F5F5\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-\\[\\#F6F7F8\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(246 247 248 / var(--tw-bg-opacity));
}
.bg-\\[\\#F6F8F980\\] {
	background-color: #F6F8F980;
}
.bg-\\[\\#F6FAFB\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(246 250 251 / var(--tw-bg-opacity));
}
.bg-\\[\\#FBFBFB\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(251 251 251 / var(--tw-bg-opacity));
}
.bg-\\[\\#FBFBFC\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(251 251 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#FEFEFE\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFC670\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(255 198 112 / var(--tw-bg-opacity));
}
.bg-\\[\\#fefefe\\] {
	--tw-bg-opacity: 1;
	background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}
.bg-black\\/30 {
	background-color: rgb(0 0 0 / 0.3);
}
.bg-blue-100 {
	--tw-bg-opacity: 1;
	background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-fortcore-green {
	--tw-bg-opacity: 1;
	background-color: rgb(0 82 93 / var(--tw-bg-opacity));
}
.bg-gray-100 {
	--tw-bg-opacity: 1;
	background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-50 {
	--tw-bg-opacity: 1;
	background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-inherit {
	background-color: inherit;
}
.bg-primary-color {
	--tw-bg-opacity: 1;
	background-color: rgb(0 58 80 / var(--tw-bg-opacity));
}
.bg-red-500 {
	--tw-bg-opacity: 1;
	background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-600 {
	--tw-bg-opacity: 1;
	background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-red-700 {
	--tw-bg-opacity: 1;
	background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.bg-slate-300\\/70 {
	background-color: rgb(203 213 225 / 0.7);
}
.bg-stone-300 {
	--tw-bg-opacity: 1;
	background-color: rgb(214 211 209 / var(--tw-bg-opacity));
}
.bg-transparent {
	background-color: transparent;
}
.bg-white {
	--tw-bg-opacity: 1;
	background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.object-contain {
	object-fit: contain;
}
.p-0 {
	padding: 0px;
}
.p-0\\.5 {
	padding: 0.125rem;
}
.p-1 {
	padding: 0.25rem;
}
.p-2 {
	padding: 0.5rem;
}
.p-2\\.5 {
	padding: 0.625rem;
}
.p-3 {
	padding: 0.75rem;
}
.p-3\\.5 {
	padding: 0.875rem;
}
.p-4 {
	padding: 1rem;
}
.p-5 {
	padding: 1.25rem;
}
.p-6 {
	padding: 1.5rem;
}
.px-1 {
	padding-left: 0.25rem;
	padding-right: 0.25rem;
}
.px-1\\.5 {
	padding-left: 0.375rem;
	padding-right: 0.375rem;
}
.px-2 {
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}
.px-2\\.5 {
	padding-left: 0.625rem;
	padding-right: 0.625rem;
}
.px-3 {
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}
.px-3\\.5 {
	padding-left: 0.875rem;
	padding-right: 0.875rem;
}
.px-4 {
	padding-left: 1rem;
	padding-right: 1rem;
}
.px-5 {
	padding-left: 1.25rem;
	padding-right: 1.25rem;
}
.px-6 {
	padding-left: 1.5rem;
	padding-right: 1.5rem;
}
.px-\\[50px\\] {
	padding-left: 50px;
	padding-right: 50px;
}
.py-0 {
	padding-top: 0px;
	padding-bottom: 0px;
}
.py-0\\.5 {
	padding-top: 0.125rem;
	padding-bottom: 0.125rem;
}
.py-1 {
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
}
.py-1\\.5 {
	padding-top: 0.375rem;
	padding-bottom: 0.375rem;
}
.py-2 {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}
.py-2\\.5 {
	padding-top: 0.625rem;
	padding-bottom: 0.625rem;
}
.py-3 {
	padding-top: 0.75rem;
	padding-bottom: 0.75rem;
}
.py-3\\.5 {
	padding-top: 0.875rem;
	padding-bottom: 0.875rem;
}
.py-4 {
	padding-top: 1rem;
	padding-bottom: 1rem;
}
.py-5 {
	padding-top: 1.25rem;
	padding-bottom: 1.25rem;
}
.py-6 {
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
}
.\\!pb-6 {
	padding-bottom: 1.5rem !important;
}
.pb-0 {
	padding-bottom: 0px;
}
.pb-1 {
	padding-bottom: 0.25rem;
}
.pb-1\\.5 {
	padding-bottom: 0.375rem;
}
.pb-10 {
	padding-bottom: 2.5rem;
}
.pb-12 {
	padding-bottom: 3rem;
}
.pb-2 {
	padding-bottom: 0.5rem;
}
.pb-2\\.5 {
	padding-bottom: 0.625rem;
}
.pb-3 {
	padding-bottom: 0.75rem;
}
.pb-4 {
	padding-bottom: 1rem;
}
.pb-5 {
	padding-bottom: 1.25rem;
}
.pb-6 {
	padding-bottom: 1.5rem;
}
.pb-7 {
	padding-bottom: 1.75rem;
}
.pb-8 {
	padding-bottom: 2rem;
}
.pl-2 {
	padding-left: 0.5rem;
}
.pl-2\\.5 {
	padding-left: 0.625rem;
}
.pl-3 {
	padding-left: 0.75rem;
}
.pl-4 {
	padding-left: 1rem;
}
.pl-\\[45px\\] {
	padding-left: 45px;
}
.pl-\\[48px\\] {
	padding-left: 48px;
}
.pl-\\[50px\\] {
	padding-left: 50px;
}
.pr-0 {
	padding-right: 0px;
}
.pr-0\\.5 {
	padding-right: 0.125rem;
}
.pr-1 {
	padding-right: 0.25rem;
}
.pr-2 {
	padding-right: 0.5rem;
}
.pr-2\\.5 {
	padding-right: 0.625rem;
}
.pr-4 {
	padding-right: 1rem;
}
.pr-5 {
	padding-right: 1.25rem;
}
.pr-6 {
	padding-right: 1.5rem;
}
.pr-\\[125px\\] {
	padding-right: 125px;
}
.pt-0 {
	padding-top: 0px;
}
.pt-0\\.5 {
	padding-top: 0.125rem;
}
.pt-1 {
	padding-top: 0.25rem;
}
.pt-2 {
	padding-top: 0.5rem;
}
.pt-3 {
	padding-top: 0.75rem;
}
.pt-4 {
	padding-top: 1rem;
}
.pt-5 {
	padding-top: 1.25rem;
}
.pt-6 {
	padding-top: 1.5rem;
}
.pt-7 {
	padding-top: 1.75rem;
}
.text-center {
	text-align: center;
}
.text-justify {
	text-align: justify;
}
.text-start {
	text-align: start;
}
.text-end {
	text-align: end;
}
.\\!text-\\[12\\.5px\\] {
	font-size: 12.5px !important;
}
.text-2xl {
	font-size: 1.5rem;
	line-height: 2rem;
}
.text-\\[10\\.5px\\] {
	font-size: 10.5px;
}
.text-\\[10px\\] {
	font-size: 10px;
}
.text-\\[11\\.25px\\] {
	font-size: 11.25px;
}
.text-\\[11\\.5px\\] {
	font-size: 11.5px;
}
.text-\\[11px\\] {
	font-size: 11px;
}
.text-\\[12\\.25px\\] {
	font-size: 12.25px;
}
.text-\\[12\\.5px\\] {
	font-size: 12.5px;
}
.text-\\[12\\.75px\\] {
	font-size: 12.75px;
}
.text-\\[13\\.5px\\] {
	font-size: 13.5px;
}
.text-\\[13px\\] {
	font-size: 13px;
}
.text-\\[14\\.5px\\] {
	font-size: 14.5px;
}
.text-\\[15px\\] {
	font-size: 15px;
}
.text-\\[17px\\] {
	font-size: 17px;
}
.text-lg {
	font-size: 1.125rem;
	line-height: 1.75rem;
}
.text-sm {
	font-size: 0.875rem;
	line-height: 1.25rem;
}
.text-xl {
	font-size: 1.25rem;
	line-height: 1.75rem;
}
.text-xs {
	font-size: 0.75rem;
	line-height: 1rem;
}
.font-black {
	font-weight: 900;
}
.font-bold {
	font-weight: 700;
}
.font-medium {
	font-weight: 500;
}
.font-normal {
	font-weight: 400;
}
.font-semibold {
	font-weight: 600;
}
.uppercase {
	text-transform: uppercase;
}
.lowercase {
	text-transform: lowercase;
}
.capitalize {
	text-transform: capitalize;
}
.italic {
	font-style: italic;
}
.leading-4 {
	line-height: 1rem;
}
.leading-5 {
	line-height: 1.25rem;
}
.leading-6 {
	line-height: 1.5rem;
}
.leading-7 {
	line-height: 1.75rem;
}
.leading-\\[18px\\] {
	line-height: 18px;
}
.leading-\\[5px\\] {
	line-height: 5px;
}
.leading-relaxed {
	line-height: 1.625;
}
.tracking-wide {
	letter-spacing: 0.025em;
}
.tracking-wider {
	letter-spacing: 0.05em;
}
.\\!text-\\[\\#393F42\\] {
	--tw-text-opacity: 1 !important;
	color: rgb(57 63 66 / var(--tw-text-opacity)) !important;
}
.\\!text-\\[\\#8E9DA4\\] {
	--tw-text-opacity: 1 !important;
	color: rgb(142 157 164 / var(--tw-text-opacity)) !important;
}
.\\!text-\\[\\#B8B8B8\\] {
	--tw-text-opacity: 1 !important;
	color: rgb(184 184 184 / var(--tw-text-opacity)) !important;
}
.\\!text-\\[\\#FF8787\\] {
	--tw-text-opacity: 1 !important;
	color: rgb(255 135 135 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#000000de\\] {
	color: #000000de;
}
.text-\\[\\#00131B\\] {
	--tw-text-opacity: 1;
	color: rgb(0 19 27 / var(--tw-text-opacity));
}
.text-\\[\\#222627\\] {
	--tw-text-opacity: 1;
	color: rgb(34 38 39 / var(--tw-text-opacity));
}
.text-\\[\\#393F42\\] {
	--tw-text-opacity: 1;
	color: rgb(57 63 66 / var(--tw-text-opacity));
}
.text-\\[\\#393f42\\] {
	--tw-text-opacity: 1;
	color: rgb(57 63 66 / var(--tw-text-opacity));
}
.text-\\[\\#555555\\] {
	--tw-text-opacity: 1;
	color: rgb(85 85 85 / var(--tw-text-opacity));
}
.text-\\[\\#555F63\\] {
	--tw-text-opacity: 1;
	color: rgb(85 95 99 / var(--tw-text-opacity));
}
.text-\\[\\#557C8A\\] {
	--tw-text-opacity: 1;
	color: rgb(85 124 138 / var(--tw-text-opacity));
}
.text-\\[\\#5A6063\\] {
	--tw-text-opacity: 1;
	color: rgb(90 96 99 / var(--tw-text-opacity));
}
.text-\\[\\#645786\\] {
	--tw-text-opacity: 1;
	color: rgb(100 87 134 / var(--tw-text-opacity));
}
.text-\\[\\#717E83\\] {
	--tw-text-opacity: 1;
	color: rgb(113 126 131 / var(--tw-text-opacity));
}
.text-\\[\\#788084\\] {
	--tw-text-opacity: 1;
	color: rgb(120 128 132 / var(--tw-text-opacity));
}
.text-\\[\\#879094\\] {
	--tw-text-opacity: 1;
	color: rgb(135 144 148 / var(--tw-text-opacity));
}
.text-\\[\\#8E9DA490\\] {
	color: #8E9DA490;
}
.text-\\[\\#8E9DA4\\] {
	--tw-text-opacity: 1;
	color: rgb(142 157 164 / var(--tw-text-opacity));
}
.text-\\[\\#8E9DA4\\]\\/90 {
	color: rgb(142 157 164 / 0.9);
}
.text-\\[\\#8b8b8b\\] {
	--tw-text-opacity: 1;
	color: rgb(139 139 139 / var(--tw-text-opacity));
}
.text-\\[\\#96A0A5\\] {
	--tw-text-opacity: 1;
	color: rgb(150 160 165 / var(--tw-text-opacity));
}
.text-\\[\\#AABDC5\\] {
	--tw-text-opacity: 1;
	color: rgb(170 189 197 / var(--tw-text-opacity));
}
.text-\\[\\#B8B8B8\\] {
	--tw-text-opacity: 1;
	color: rgb(184 184 184 / var(--tw-text-opacity));
}
.text-\\[\\#E3E9EC\\] {
	--tw-text-opacity: 1;
	color: rgb(227 233 236 / var(--tw-text-opacity));
}
.text-\\[\\#EEF2F3\\] {
	--tw-text-opacity: 1;
	color: rgb(238 242 243 / var(--tw-text-opacity));
}
.text-\\[\\#FF4A4A\\] {
	--tw-text-opacity: 1;
	color: rgb(255 74 74 / var(--tw-text-opacity));
}
.text-\\[\\#FF7676\\] {
	--tw-text-opacity: 1;
	color: rgb(255 118 118 / var(--tw-text-opacity));
}
.text-\\[\\#FFC214\\] {
	--tw-text-opacity: 1;
	color: rgb(255 194 20 / var(--tw-text-opacity));
}
.text-\\[\\#b2b2b2\\] {
	--tw-text-opacity: 1;
	color: rgb(178 178 178 / var(--tw-text-opacity));
}
.text-black {
	--tw-text-opacity: 1;
	color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-black\\/80 {
	color: rgb(0 0 0 / 0.8);
}
.text-blue-600 {
	--tw-text-opacity: 1;
	color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-700 {
	--tw-text-opacity: 1;
	color: rgb(29 78 216 / var(--tw-text-opacity));
}
.text-blue-800 {
	--tw-text-opacity: 1;
	color: rgb(30 64 175 / var(--tw-text-opacity));
}
.text-fortcore-green {
	--tw-text-opacity: 1;
	color: rgb(0 82 93 / var(--tw-text-opacity));
}
.text-gray-200 {
	--tw-text-opacity: 1;
	color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-300 {
	--tw-text-opacity: 1;
	color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400 {
	--tw-text-opacity: 1;
	color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
	--tw-text-opacity: 1;
	color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
	--tw-text-opacity: 1;
	color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-green-500 {
	--tw-text-opacity: 1;
	color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-600 {
	--tw-text-opacity: 1;
	color: rgb(22 163 74 / var(--tw-text-opacity));
}
.text-green-700 {
	--tw-text-opacity: 1;
	color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-primary-color {
	--tw-text-opacity: 1;
	color: rgb(0 58 80 / var(--tw-text-opacity));
}
.text-red-400 {
	--tw-text-opacity: 1;
	color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500 {
	--tw-text-opacity: 1;
	color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
	--tw-text-opacity: 1;
	color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-slate-500 {
	--tw-text-opacity: 1;
	color: rgb(100 116 139 / var(--tw-text-opacity));
}
.text-white {
	--tw-text-opacity: 1;
	color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
	text-decoration-line: underline;
}
.opacity-75 {
	opacity: 0.75;
}
.mix-blend-multiply {
	mix-blend-mode: multiply;
}
.shadow-lg {
	--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
	--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
	--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
	outline: 2px solid transparent;
	outline-offset: 2px;
}
.outline {
	outline-style: solid;
}
.blur {
	--tw-blur: blur(8px);
	filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-2xl {
	--tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
	filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
	filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[2px\\] {
	--tw-backdrop-blur: blur(2px);
	-webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
	        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
	-webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
	        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
	transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
	transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
	transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}
.transition-all {
	transition-property: all;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}
.transition-colors {
	transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}
.transition-shadow {
	transition-property: box-shadow;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}
.transition-transform {
	transition-property: transform;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}
.ease-in-out {
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@font-face {
	font-family: "ZabalRegular";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
	font-family: "ZabalMedium";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
	font-family: "ZabalBold";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.logoBg {
	background: linear-gradient(
		180deg,
		#476569 -291.25%,
		rgba(254, 254, 254, 0) 100%
	);
	-webkit-backdrop-filter: blur(4px);
	        backdrop-filter: blur(4px);
}

input:focus {
	outline: none;
}

.lInput {
	background: rgba(113, 126, 131, 0.7);
}

@media screen and (min-width: 600px) {
	.lInput {
		background: transparent;
	}
}
.zabalRegFont {
	font-family: "ZabalRegular", sans-serif;
}
.zabalMedFont {
	font-family: "ZabalMedium", sans-serif;
}
.zabalBoldFont {
	font-family: "ZabalBold", sans-serif;
}
.chillaxFont {
	font-family: "Chillax", sans-serif;
}
.activeLink {
	background: linear-gradient(90deg, #ffffff 19.02%, #ffffff00 183%);
}
.blueGradient {
	background: linear-gradient(
		0deg,
		#eff8f9 -33.24%,
		rgba(239, 248, 249, 0) 123.74%
	);
}
.bigSelectOpen {
	box-shadow: 0px 4px 16px #eef2f3;
}
.bigSelectOpen .innerCard:hover {
	background: linear-gradient(
		0deg,
		#eff8f9 -33.24%,
		rgba(239, 248, 249, 0) 123.74%
	);
}
.indexBalance {
	box-shadow: 2px 2px 12px 0px #5d65661f;
}
.transactCard:first-of-type {
	filter: drop-shadow(0px 4px 16px #eef2f3);
}
.payment:hover {
	box-shadow: 0px 4px 12px rgba(126, 126, 126, 0.08);
}
.scroll-wrapper {
	padding-bottom: 0.2rem;
	overflow-x: auto;
	scrollbar-width: thin;
}
.scroll-wrapper::-webkit-scrollbar {
	height: 6px;
	width: 6px;
	display: none;
}
@media (min-width: 640px) {
	.scroll-wrapper::-webkit-scrollbar {
		display: block;
	}
}

/* Track */
.scroll-wrapper::-webkit-scrollbar-track {
	background: #8c30f512;
	border-radius: 10px;
}

/* Handle */
.scroll-wrapper::-webkit-scrollbar-thumb {
	background: gainsboro;
	border-radius: 10px;
}

/* Handle on hover */
.scroll-wrapper::-webkit-scrollbar-thumb:hover {
	background: #b4b1b8;
}

.tooltip:hover .tooltiptext {
	visibility: visible;
}

.tooltip .tooltiptext::after {
	content: " ";
	position: absolute;
	top: 100%; /* At the bottom of the tooltip */
	left: 50%;
	margin-left: -5px;
	border-width: 5px;
	border-style: solid;
	border-color: #00525d transparent transparent transparent;
}

.carousel-root {
	width: 100%;
}

li.slide {
	display: flex;
	align-items: center;
	justify-content: center;
}

.swiper-button-next,
.swiper-button-prev {
	position: absolute !important;
	z-index: 15;
	background: white;
	box-shadow: 0px 1px 20px 0px #b8c8cf;
	width: 30px !important;
	height: 30px !important;
	border-radius: 9999px;
}

.swiper-button-next::after,
.swiper-button-prev::after {
	font-size: 12px !important;
	color: #003a50 !important;
	font-weight: bolder;
}

.swiper-button-prev {
	left: -5px !important;
}

.swiper-button-next {
	right: -2px !important;
}

.loginBtnLoading {
	width: 48px;
	height: 48px;
	border-radius: 999px;
	background: #8e9da4;
	transition: all linear 0.2s;
}

.loginBtn {
	width: 100%;
	height: 45px;
	border-radius: 8px;
	background: #00525d;
	/* transition: borderRadius linear 0.5s 2s; */
	transition: all linear 0.5s;
}

.blink {
	animation-name: viewBtnBlink;
	animation-duration: 2s;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-fill-mode: both;
}

@keyframes viewBtnBlink {
	0% {
		color: #00525d;
		border-color: #00525d;
	}

	50% {
		color: red;
		border-color: red;
	}

	100% {
		color: #00525d;
		border-color: #00525d;
	}
}

.placeholder\\:text-\\[12\\.5px\\]::placeholder {
	font-size: 12.5px;
}

.placeholder\\:text-\\[13px\\]::placeholder {
	font-size: 13px;
}

.placeholder\\:italic::placeholder {
	font-style: italic;
}

.placeholder\\:text-\\[\\#717e83\\]::placeholder {
	--tw-text-opacity: 1;
	color: rgb(113 126 131 / var(--tw-text-opacity));
}

.placeholder\\:text-\\[\\#879094\\]::placeholder {
	--tw-text-opacity: 1;
	color: rgb(135 144 148 / var(--tw-text-opacity));
}

.placeholder\\:text-\\[\\#AABDC5\\]::placeholder {
	--tw-text-opacity: 1;
	color: rgb(170 189 197 / var(--tw-text-opacity));
}

.placeholder\\:text-\\[\\#B8B8B8\\]::placeholder {
	--tw-text-opacity: 1;
	color: rgb(184 184 184 / var(--tw-text-opacity));
}

.placeholder\\:text-\\[\\#B8C8CF\\]::placeholder {
	--tw-text-opacity: 1;
	color: rgb(184 200 207 / var(--tw-text-opacity));
}

.last\\:border-none:last-child {
	border-style: none;
}

.hover\\:scale-\\[1\\.01\\]:hover {
	--tw-scale-x: 1.01;
	--tw-scale-y: 1.01;
	transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.025\\]:hover {
	--tw-scale-x: 1.025;
	--tw-scale-y: 1.025;
	transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:rounded-md:hover {
	border-radius: 0.375rem;
}

.hover\\:border-\\[\\#557C8A\\]:hover {
	--tw-border-opacity: 1;
	border-color: rgb(85 124 138 / var(--tw-border-opacity));
}

.hover\\:border-\\[\\#AABDC5\\]:hover {
	--tw-border-opacity: 1;
	border-color: rgb(170 189 197 / var(--tw-border-opacity));
}

.hover\\:bg-\\[\\#0000000a\\]:hover {
	background-color: #0000000a;
}

.hover\\:bg-\\[\\#EEF2F3\\]:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(238 242 243 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#EFF8F9\\]:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(239 248 249 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-50:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}

.hover\\:bg-red-500:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}

.hover\\:bg-slate-50:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}

.hover\\:px-3:hover {
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}

.hover\\:font-semibold:hover {
	font-weight: 600;
}

.hover\\:text-fortcore-green:hover {
	--tw-text-opacity: 1;
	color: rgb(0 82 93 / var(--tw-text-opacity));
}

.hover\\:text-primary-color:hover {
	--tw-text-opacity: 1;
	color: rgb(0 58 80 / var(--tw-text-opacity));
}

.hover\\:text-red-400:hover {
	--tw-text-opacity: 1;
	color: rgb(248 113 113 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
	--tw-text-opacity: 1;
	color: rgb(255 255 255 / var(--tw-text-opacity));
}

.focus\\:\\!border-2:focus {
	border-width: 2px !important;
}

.focus\\:border-2:focus {
	border-width: 2px;
}

.focus\\:\\!border-fortcore-green:focus {
	--tw-border-opacity: 1 !important;
	border-color: rgb(0 82 93 / var(--tw-border-opacity)) !important;
}

.focus\\:border-fortcore-green:focus {
	--tw-border-opacity: 1;
	border-color: rgb(0 82 93 / var(--tw-border-opacity));
}

.focus\\:border-primary-color:focus {
	--tw-border-opacity: 1;
	border-color: rgb(0 58 80 / var(--tw-border-opacity));
}

@media (min-width: 640px) {

	.sm\\:left-\\[155px\\] {
		left: 155px;
	}

	.sm\\:top-\\[57px\\] {
		top: 57px;
	}

	.sm\\:col-span-2 {
		grid-column: span 2 / span 2;
	}

	.sm\\:col-span-3 {
		grid-column: span 3 / span 3;
	}

	.sm\\:my-10 {
		margin-top: 2.5rem;
		margin-bottom: 2.5rem;
	}

	.sm\\:my-5 {
		margin-top: 1.25rem;
		margin-bottom: 1.25rem;
	}

	.sm\\:my-6 {
		margin-top: 1.5rem;
		margin-bottom: 1.5rem;
	}

	.sm\\:my-8 {
		margin-top: 2rem;
		margin-bottom: 2rem;
	}

	.sm\\:\\!mt-1 {
		margin-top: 0.25rem !important;
	}

	.sm\\:\\!mt-5 {
		margin-top: 1.25rem !important;
	}

	.sm\\:-mb-1 {
		margin-bottom: -0.25rem;
	}

	.sm\\:-mb-1\\.5 {
		margin-bottom: -0.375rem;
	}

	.sm\\:mb-14 {
		margin-bottom: 3.5rem;
	}

	.sm\\:mb-6 {
		margin-bottom: 1.5rem;
	}

	.sm\\:mt-0 {
		margin-top: 0px;
	}

	.sm\\:mt-1 {
		margin-top: 0.25rem;
	}

	.sm\\:mt-1\\.5 {
		margin-top: 0.375rem;
	}

	.sm\\:mt-10 {
		margin-top: 2.5rem;
	}

	.sm\\:mt-12 {
		margin-top: 3rem;
	}

	.sm\\:mt-14 {
		margin-top: 3.5rem;
	}

	.sm\\:mt-6 {
		margin-top: 1.5rem;
	}

	.sm\\:mt-7 {
		margin-top: 1.75rem;
	}

	.sm\\:mt-8 {
		margin-top: 2rem;
	}

	.sm\\:mt-\\[30px\\] {
		margin-top: 30px;
	}

	.sm\\:mt-\\[55px\\] {
		margin-top: 55px;
	}

	.sm\\:block {
		display: block;
	}

	.sm\\:inline {
		display: inline;
	}

	.sm\\:flex {
		display: flex;
	}

	.sm\\:grid {
		display: grid;
	}

	.sm\\:\\!hidden {
		display: none !important;
	}

	.sm\\:hidden {
		display: none;
	}

	.sm\\:h-\\[110px\\] {
		height: 110px;
	}

	.sm\\:h-\\[135px\\] {
		height: 135px;
	}

	.sm\\:h-\\[150px\\] {
		height: 150px;
	}

	.sm\\:h-\\[25px\\] {
		height: 25px;
	}

	.sm\\:h-\\[300px\\] {
		height: 300px;
	}

	.sm\\:h-\\[370px\\] {
		height: 370px;
	}

	.sm\\:h-\\[400px\\] {
		height: 400px;
	}

	.sm\\:h-\\[45px\\] {
		height: 45px;
	}

	.sm\\:h-\\[55px\\] {
		height: 55px;
	}

	.sm\\:h-\\[57px\\] {
		height: 57px;
	}

	.sm\\:h-\\[75px\\] {
		height: 75px;
	}

	.sm\\:h-\\[84vh\\] {
		height: 84vh;
	}

	.sm\\:h-\\[85px\\] {
		height: 85px;
	}

	.sm\\:h-\\[85vh\\] {
		height: 85vh;
	}

	.sm\\:h-\\[90vh\\] {
		height: 90vh;
	}

	.sm\\:max-h-\\[110px\\] {
		max-height: 110px;
	}

	.sm\\:max-h-\\[120px\\] {
		max-height: 120px;
	}

	.sm\\:max-h-\\[450px\\] {
		max-height: 450px;
	}

	.sm\\:max-h-\\[600px\\] {
		max-height: 600px;
	}

	.sm\\:max-h-\\[84vh\\] {
		max-height: 84vh;
	}

	.sm\\:min-h-\\[125px\\] {
		min-height: 125px;
	}

	.sm\\:min-h-\\[150px\\] {
		min-height: 150px;
	}

	.sm\\:min-h-\\[180px\\] {
		min-height: 180px;
	}

	.sm\\:\\!w-\\[120px\\] {
		width: 120px !important;
	}

	.sm\\:w-1\\/3 {
		width: 33.333333%;
	}

	.sm\\:w-10\\/12 {
		width: 83.333333%;
	}

	.sm\\:w-11\\/12 {
		width: 91.666667%;
	}

	.sm\\:w-2\\/3 {
		width: 66.666667%;
	}

	.sm\\:w-2\\/6 {
		width: 33.333333%;
	}

	.sm\\:w-4\\/6 {
		width: 66.666667%;
	}

	.sm\\:w-8\\/12 {
		width: 66.666667%;
	}

	.sm\\:w-9\\/12 {
		width: 75%;
	}

	.sm\\:w-\\[120px\\] {
		width: 120px;
	}

	.sm\\:w-\\[155px\\] {
		width: 155px;
	}

	.sm\\:w-\\[240px\\] {
		width: 240px;
	}

	.sm\\:w-\\[28\\%\\] {
		width: 28%;
	}

	.sm\\:w-\\[30\\%\\] {
		width: 30%;
	}

	.sm\\:w-\\[32\\%\\] {
		width: 32%;
	}

	.sm\\:w-\\[33\\%\\] {
		width: 33%;
	}

	.sm\\:w-\\[35\\%\\] {
		width: 35%;
	}

	.sm\\:w-\\[40\\%\\] {
		width: 40%;
	}

	.sm\\:w-\\[440px\\] {
		width: 440px;
	}

	.sm\\:w-\\[60\\%\\] {
		width: 60%;
	}

	.sm\\:w-\\[65\\%\\] {
		width: 65%;
	}

	.sm\\:w-\\[67\\%\\] {
		width: 67%;
	}

	.sm\\:w-\\[70\\%\\] {
		width: 70%;
	}

	.sm\\:w-\\[72\\%\\] {
		width: 72%;
	}

	.sm\\:w-\\[82\\%\\] {
		width: 82%;
	}

	.sm\\:w-\\[calc\\(100\\%-155px\\)\\] {
		width: calc(100% - 155px);
	}

	.sm\\:min-w-\\[355px\\] {
		min-width: 355px;
	}

	.sm\\:min-w-\\[450px\\] {
		min-width: 450px;
	}

	.sm\\:min-w-\\[500px\\] {
		min-width: 500px;
	}

	.sm\\:max-w-\\[150px\\] {
		max-width: 150px;
	}

	.sm\\:max-w-\\[300px\\] {
		max-width: 300px;
	}

	.sm\\:max-w-\\[360px\\] {
		max-width: 360px;
	}

	.sm\\:max-w-\\[410px\\] {
		max-width: 410px;
	}

	.sm\\:max-w-\\[470px\\] {
		max-width: 470px;
	}

	.sm\\:max-w-\\[500px\\] {
		max-width: 500px;
	}

	.sm\\:max-w-\\[550px\\] {
		max-width: 550px;
	}

	.sm\\:max-w-\\[700px\\] {
		max-width: 700px;
	}

	.sm\\:max-w-none {
		max-width: none;
	}

	.sm\\:grid-cols-2 {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.sm\\:grid-cols-3 {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.sm\\:grid-cols-7 {
		grid-template-columns: repeat(7, minmax(0, 1fr));
	}

	.sm\\:flex-row {
		flex-direction: row;
	}

	.sm\\:flex-col {
		flex-direction: column;
	}

	.sm\\:items-start {
		align-items: flex-start;
	}

	.sm\\:items-center {
		align-items: center;
	}

	.sm\\:justify-normal {
		justify-content: normal;
	}

	.sm\\:justify-start {
		justify-content: flex-start;
	}

	.sm\\:justify-end {
		justify-content: flex-end;
	}

	.sm\\:justify-center {
		justify-content: center;
	}

	.sm\\:justify-between {
		justify-content: space-between;
	}

	.sm\\:gap-0 {
		gap: 0px;
	}

	.sm\\:gap-1 {
		gap: 0.25rem;
	}

	.sm\\:gap-1\\.5 {
		gap: 0.375rem;
	}

	.sm\\:gap-2 {
		gap: 0.5rem;
	}

	.sm\\:gap-3 {
		gap: 0.75rem;
	}

	.sm\\:gap-3\\.5 {
		gap: 0.875rem;
	}

	.sm\\:gap-4 {
		gap: 1rem;
	}

	.sm\\:gap-5 {
		gap: 1.25rem;
	}

	.sm\\:gap-6 {
		gap: 1.5rem;
	}

	.sm\\:gap-7 {
		gap: 1.75rem;
	}

	.sm\\:gap-8 {
		gap: 2rem;
	}

	.sm\\:gap-x-4 {
		column-gap: 1rem;
	}

	.sm\\:gap-x-5 {
		column-gap: 1.25rem;
	}

	.sm\\:gap-y-4 {
		row-gap: 1rem;
	}

	.sm\\:gap-y-5 {
		row-gap: 1.25rem;
	}

	.sm\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
	}

	.sm\\:space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
	}

	.sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
	}

	.sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
	}

	.sm\\:justify-self-end {
		justify-self: end;
	}

	.sm\\:rounded-md {
		border-radius: 0.375rem;
	}

	.sm\\:border-none {
		border-style: none;
	}

	.sm\\:border-transparent {
		border-color: transparent;
	}

	.sm\\:bg-\\[\\#F6F7F8\\] {
		--tw-bg-opacity: 1;
		background-color: rgb(246 247 248 / var(--tw-bg-opacity));
	}

	.sm\\:p-1 {
		padding: 0.25rem;
	}

	.sm\\:p-1\\.5 {
		padding: 0.375rem;
	}

	.sm\\:p-3 {
		padding: 0.75rem;
	}

	.sm\\:p-4 {
		padding: 1rem;
	}

	.sm\\:p-5 {
		padding: 1.25rem;
	}

	.sm\\:p-6 {
		padding: 1.5rem;
	}

	.sm\\:px-3 {
		padding-left: 0.75rem;
		padding-right: 0.75rem;
	}

	.sm\\:px-3\\.5 {
		padding-left: 0.875rem;
		padding-right: 0.875rem;
	}

	.sm\\:px-5 {
		padding-left: 1.25rem;
		padding-right: 1.25rem;
	}

	.sm\\:px-6 {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	}

	.sm\\:px-8 {
		padding-left: 2rem;
		padding-right: 2rem;
	}

	.sm\\:py-2 {
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
	}

	.sm\\:py-3 {
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
	}

	.sm\\:py-4 {
		padding-top: 1rem;
		padding-bottom: 1rem;
	}

	.sm\\:py-5 {
		padding-top: 1.25rem;
		padding-bottom: 1.25rem;
	}

	.sm\\:py-8 {
		padding-top: 2rem;
		padding-bottom: 2rem;
	}

	.sm\\:pb-2 {
		padding-bottom: 0.5rem;
	}

	.sm\\:pb-2\\.5 {
		padding-bottom: 0.625rem;
	}

	.sm\\:pb-4 {
		padding-bottom: 1rem;
	}

	.sm\\:pb-5 {
		padding-bottom: 1.25rem;
	}

	.sm\\:pb-7 {
		padding-bottom: 1.75rem;
	}

	.sm\\:pt-8 {
		padding-top: 2rem;
	}

	.sm\\:pt-9 {
		padding-top: 2.25rem;
	}

	.sm\\:text-\\[12\\.5px\\] {
		font-size: 12.5px;
	}

	.sm\\:text-\\[13\\.5px\\] {
		font-size: 13.5px;
	}

	.sm\\:text-\\[13px\\] {
		font-size: 13px;
	}

	.sm\\:text-\\[15px\\] {
		font-size: 15px;
	}

	.sm\\:text-base {
		font-size: 1rem;
		line-height: 1.5rem;
	}

	.sm\\:text-sm {
		font-size: 0.875rem;
		line-height: 1.25rem;
	}

	.sm\\:text-xs {
		font-size: 0.75rem;
		line-height: 1rem;
	}

	.sm\\:font-medium {
		font-weight: 500;
	}

	.sm\\:text-fortcore-green {
		--tw-text-opacity: 1;
		color: rgb(0 82 93 / var(--tw-text-opacity));
	}
}

@media (min-width: 864px) {

	.md\\:left-\\[170px\\] {
		left: 170px;
	}

	.md\\:right-10 {
		right: 2.5rem;
	}

	.md\\:top-0 {
		top: 0px;
	}

	.md\\:top-\\[63px\\] {
		top: 63px;
	}

	.md\\:col-span-4 {
		grid-column: span 4 / span 4;
	}

	.md\\:mx-5 {
		margin-left: 1.25rem;
		margin-right: 1.25rem;
	}

	.md\\:my-12 {
		margin-top: 3rem;
		margin-bottom: 3rem;
	}

	.md\\:my-6 {
		margin-top: 1.5rem;
		margin-bottom: 1.5rem;
	}

	.md\\:my-7 {
		margin-top: 1.75rem;
		margin-bottom: 1.75rem;
	}

	.md\\:-mt-5 {
		margin-top: -1.25rem;
	}

	.md\\:mb-10 {
		margin-bottom: 2.5rem;
	}

	.md\\:mb-4 {
		margin-bottom: 1rem;
	}

	.md\\:ml-3 {
		margin-left: 0.75rem;
	}

	.md\\:mt-14 {
		margin-top: 3.5rem;
	}

	.md\\:mt-16 {
		margin-top: 4rem;
	}

	.md\\:mt-3 {
		margin-top: 0.75rem;
	}

	.md\\:mt-5 {
		margin-top: 1.25rem;
	}

	.md\\:mt-7 {
		margin-top: 1.75rem;
	}

	.md\\:mt-8 {
		margin-top: 2rem;
	}

	.md\\:\\!block {
		display: block !important;
	}

	.md\\:block {
		display: block;
	}

	.md\\:inline {
		display: inline;
	}

	.md\\:flex {
		display: flex;
	}

	.md\\:hidden {
		display: none;
	}

	.md\\:\\!h-\\[45px\\] {
		height: 45px !important;
	}

	.md\\:h-3 {
		height: 0.75rem;
	}

	.md\\:h-4 {
		height: 1rem;
	}

	.md\\:h-\\[120px\\] {
		height: 120px;
	}

	.md\\:h-\\[130px\\] {
		height: 130px;
	}

	.md\\:h-\\[140px\\] {
		height: 140px;
	}

	.md\\:h-\\[150px\\] {
		height: 150px;
	}

	.md\\:h-\\[157px\\] {
		height: 157px;
	}

	.md\\:h-\\[20px\\] {
		height: 20px;
	}

	.md\\:h-\\[210px\\] {
		height: 210px;
	}

	.md\\:h-\\[250px\\] {
		height: 250px;
	}

	.md\\:h-\\[25px\\] {
		height: 25px;
	}

	.md\\:h-\\[270px\\] {
		height: 270px;
	}

	.md\\:h-\\[30px\\] {
		height: 30px;
	}

	.md\\:h-\\[34px\\] {
		height: 34px;
	}

	.md\\:h-\\[350px\\] {
		height: 350px;
	}

	.md\\:h-\\[35px\\] {
		height: 35px;
	}

	.md\\:h-\\[370px\\] {
		height: 370px;
	}

	.md\\:h-\\[38px\\] {
		height: 38px;
	}

	.md\\:h-\\[450px\\] {
		height: 450px;
	}

	.md\\:h-\\[45px\\] {
		height: 45px;
	}

	.md\\:h-\\[55vh\\] {
		height: 55vh;
	}

	.md\\:h-\\[60px\\] {
		height: 60px;
	}

	.md\\:h-\\[63px\\] {
		height: 63px;
	}

	.md\\:h-\\[85px\\] {
		height: 85px;
	}

	.md\\:h-\\[87vh\\] {
		height: 87vh;
	}

	.md\\:h-\\[90px\\] {
		height: 90px;
	}

	.md\\:h-\\[92vh\\] {
		height: 92vh;
	}

	.md\\:h-auto {
		height: auto;
	}

	.md\\:max-h-\\[120px\\] {
		max-height: 120px;
	}

	.md\\:max-h-\\[230px\\] {
		max-height: 230px;
	}

	.md\\:max-h-\\[240px\\] {
		max-height: 240px;
	}

	.md\\:max-h-\\[250px\\] {
		max-height: 250px;
	}

	.md\\:max-h-\\[350px\\] {
		max-height: 350px;
	}

	.md\\:max-h-\\[87vh\\] {
		max-height: 87vh;
	}

	.md\\:min-h-\\[130px\\] {
		min-height: 130px;
	}

	.md\\:w-1\\/5 {
		width: 20%;
	}

	.md\\:w-10\\/12 {
		width: 83.333333%;
	}

	.md\\:w-11\\/12 {
		width: 91.666667%;
	}

	.md\\:w-2\\/3 {
		width: 66.666667%;
	}

	.md\\:w-2\\/5 {
		width: 40%;
	}

	.md\\:w-2\\/6 {
		width: 33.333333%;
	}

	.md\\:w-3\\/5 {
		width: 60%;
	}

	.md\\:w-4\\/12 {
		width: 33.333333%;
	}

	.md\\:w-4\\/5 {
		width: 80%;
	}

	.md\\:w-4\\/6 {
		width: 66.666667%;
	}

	.md\\:w-5\\/12 {
		width: 41.666667%;
	}

	.md\\:w-7\\/12 {
		width: 58.333333%;
	}

	.md\\:w-8\\/12 {
		width: 66.666667%;
	}

	.md\\:w-\\[100px\\] {
		width: 100px;
	}

	.md\\:w-\\[140px\\] {
		width: 140px;
	}

	.md\\:w-\\[145px\\] {
		width: 145px;
	}

	.md\\:w-\\[150px\\] {
		width: 150px;
	}

	.md\\:w-\\[16px\\] {
		width: 16px;
	}

	.md\\:w-\\[170px\\] {
		width: 170px;
	}

	.md\\:w-\\[200px\\] {
		width: 200px;
	}

	.md\\:w-\\[25\\%\\] {
		width: 25%;
	}

	.md\\:w-\\[330px\\] {
		width: 330px;
	}

	.md\\:w-\\[34px\\] {
		width: 34px;
	}

	.md\\:w-\\[35px\\] {
		width: 35px;
	}

	.md\\:w-\\[4\\/5\\] {
		width: 4/5;
	}

	.md\\:w-\\[60px\\] {
		width: 60px;
	}

	.md\\:w-\\[75\\%\\] {
		width: 75%;
	}

	.md\\:w-\\[85px\\] {
		width: 85px;
	}

	.md\\:w-\\[87\\%\\] {
		width: 87%;
	}

	.md\\:w-\\[calc\\(100\\%-170px\\)\\] {
		width: calc(100% - 170px);
	}

	.md\\:w-\\[calc\\(100\\%-37px\\)\\] {
		width: calc(100% - 37px);
	}

	.md\\:min-w-\\[365px\\] {
		min-width: 365px;
	}

	.md\\:\\!max-w-\\[220px\\] {
		max-width: 220px !important;
	}

	.md\\:max-w-\\[1100px\\] {
		max-width: 1100px;
	}

	.md\\:max-w-\\[135px\\] {
		max-width: 135px;
	}

	.md\\:max-w-\\[250px\\] {
		max-width: 250px;
	}

	.md\\:max-w-\\[310px\\] {
		max-width: 310px;
	}

	.md\\:max-w-\\[330px\\] {
		max-width: 330px;
	}

	.md\\:max-w-\\[400px\\] {
		max-width: 400px;
	}

	.md\\:max-w-\\[450px\\] {
		max-width: 450px;
	}

	.md\\:max-w-\\[700px\\] {
		max-width: 700px;
	}

	.md\\:grid-cols-2 {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.md\\:grid-cols-3 {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.md\\:grid-cols-4 {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}

	.md\\:flex-row {
		flex-direction: row;
	}

	.md\\:gap-2 {
		gap: 0.5rem;
	}

	.md\\:gap-2\\.5 {
		gap: 0.625rem;
	}

	.md\\:gap-3 {
		gap: 0.75rem;
	}

	.md\\:gap-3\\.5 {
		gap: 0.875rem;
	}

	.md\\:gap-4 {
		gap: 1rem;
	}

	.md\\:gap-5 {
		gap: 1.25rem;
	}

	.md\\:gap-6 {
		gap: 1.5rem;
	}

	.md\\:gap-7 {
		gap: 1.75rem;
	}

	.md\\:gap-8 {
		gap: 2rem;
	}

	.md\\:gap-x-5 {
		column-gap: 1.25rem;
	}

	.md\\:gap-x-7 {
		column-gap: 1.75rem;
	}

	.md\\:space-y-1 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-2 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-5 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-7 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
	}

	.md\\:space-y-8 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(2rem * var(--tw-space-y-reverse));
	}

	.md\\:rounded-sm {
		border-radius: 0.125rem;
	}

	.md\\:border-\\[\\#96A0A5\\] {
		--tw-border-opacity: 1;
		border-color: rgb(150 160 165 / var(--tw-border-opacity));
	}

	.md\\:p-3 {
		padding: 0.75rem;
	}

	.md\\:p-3\\.5 {
		padding: 0.875rem;
	}

	.md\\:p-4 {
		padding: 1rem;
	}

	.md\\:p-5 {
		padding: 1.25rem;
	}

	.md\\:p-6 {
		padding: 1.5rem;
	}

	.md\\:p-8 {
		padding: 2rem;
	}

	.md\\:px-12 {
		padding-left: 3rem;
		padding-right: 3rem;
	}

	.md\\:px-3 {
		padding-left: 0.75rem;
		padding-right: 0.75rem;
	}

	.md\\:px-3\\.5 {
		padding-left: 0.875rem;
		padding-right: 0.875rem;
	}

	.md\\:px-4 {
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.md\\:px-5 {
		padding-left: 1.25rem;
		padding-right: 1.25rem;
	}

	.md\\:px-6 {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	}

	.md\\:px-8 {
		padding-left: 2rem;
		padding-right: 2rem;
	}

	.md\\:py-2 {
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
	}

	.md\\:py-2\\.5 {
		padding-top: 0.625rem;
		padding-bottom: 0.625rem;
	}

	.md\\:py-3 {
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
	}

	.md\\:py-5 {
		padding-top: 1.25rem;
		padding-bottom: 1.25rem;
	}

	.md\\:py-6 {
		padding-top: 1.5rem;
		padding-bottom: 1.5rem;
	}

	.md\\:\\!pb-5 {
		padding-bottom: 1.25rem !important;
	}

	.md\\:pb-1 {
		padding-bottom: 0.25rem;
	}

	.md\\:pb-1\\.5 {
		padding-bottom: 0.375rem;
	}

	.md\\:pb-16 {
		padding-bottom: 4rem;
	}

	.md\\:pl-5 {
		padding-left: 1.25rem;
	}

	.md\\:pr-3 {
		padding-right: 0.75rem;
	}

	.md\\:pt-10 {
		padding-top: 2.5rem;
	}

	.md\\:pt-2 {
		padding-top: 0.5rem;
	}

	.md\\:pt-4 {
		padding-top: 1rem;
	}

	.md\\:pt-5 {
		padding-top: 1.25rem;
	}

	.md\\:pt-6 {
		padding-top: 1.5rem;
	}

	.md\\:text-\\[12\\.25px\\] {
		font-size: 12.25px;
	}

	.md\\:text-\\[12\\.5px\\] {
		font-size: 12.5px;
	}

	.md\\:text-\\[13\\.5px\\] {
		font-size: 13.5px;
	}

	.md\\:text-\\[13px\\] {
		font-size: 13px;
	}

	.md\\:text-\\[14\\.5px\\] {
		font-size: 14.5px;
	}

	.md\\:text-\\[14px\\] {
		font-size: 14px;
	}

	.md\\:text-\\[15px\\] {
		font-size: 15px;
	}

	.md\\:text-\\[18px\\] {
		font-size: 18px;
	}

	.md\\:text-base {
		font-size: 1rem;
		line-height: 1.5rem;
	}

	.md\\:text-lg {
		font-size: 1.125rem;
		line-height: 1.75rem;
	}

	.md\\:text-sm {
		font-size: 0.875rem;
		line-height: 1.25rem;
	}

	.md\\:text-xs {
		font-size: 0.75rem;
		line-height: 1rem;
	}

	.md\\:text-\\[13\\.px\\] {
		color: 13.px;
	}

	.md\\:text-fortcore-green {
		--tw-text-opacity: 1;
		color: rgb(0 82 93 / var(--tw-text-opacity));
	}
}

@media (min-width: 1056px) {

	.lg\\:left-\\[185px\\] {
		left: 185px;
	}

	.lg\\:col-span-2 {
		grid-column: span 2 / span 2;
	}

	.lg\\:col-span-4 {
		grid-column: span 4 / span 4;
	}

	.lg\\:my-10 {
		margin-top: 2.5rem;
		margin-bottom: 2.5rem;
	}

	.lg\\:my-14 {
		margin-top: 3.5rem;
		margin-bottom: 3.5rem;
	}

	.lg\\:mt-16 {
		margin-top: 4rem;
	}

	.lg\\:mt-20 {
		margin-top: 5rem;
	}

	.lg\\:flex {
		display: flex;
	}

	.lg\\:h-\\[122px\\] {
		height: 122px;
	}

	.lg\\:h-\\[125px\\] {
		height: 125px;
	}

	.lg\\:h-\\[250px\\] {
		height: 250px;
	}

	.lg\\:h-\\[88vh\\] {
		height: 88vh;
	}

	.lg\\:h-\\[90px\\] {
		height: 90px;
	}

	.lg\\:h-\\[95px\\] {
		height: 95px;
	}

	.lg\\:max-h-\\[135px\\] {
		max-height: 135px;
	}

	.lg\\:max-h-\\[270px\\] {
		max-height: 270px;
	}

	.lg\\:max-h-\\[88vh\\] {
		max-height: 88vh;
	}

	.lg\\:min-h-\\[140px\\] {
		min-height: 140px;
	}

	.lg\\:min-h-\\[170px\\] {
		min-height: 170px;
	}

	.lg\\:w-1\\/2 {
		width: 50%;
	}

	.lg\\:w-1\\/5 {
		width: 20%;
	}

	.lg\\:w-3\\/12 {
		width: 25%;
	}

	.lg\\:w-4\\/5 {
		width: 80%;
	}

	.lg\\:w-9\\/12 {
		width: 75%;
	}

	.lg\\:w-\\[185px\\] {
		width: 185px;
	}

	.lg\\:w-\\[85\\%\\] {
		width: 85%;
	}

	.lg\\:w-\\[88\\%\\] {
		width: 88%;
	}

	.lg\\:w-\\[calc\\(100\\%-185px\\)\\] {
		width: calc(100% - 185px);
	}

	.lg\\:w-\\[calc\\(100\\%-42px\\)\\] {
		width: calc(100% - 42px);
	}

	.lg\\:\\!max-w-\\[130px\\] {
		max-width: 130px !important;
	}

	.lg\\:\\!max-w-\\[180px\\] {
		max-width: 180px !important;
	}

	.lg\\:\\!max-w-\\[250px\\] {
		max-width: 250px !important;
	}

	.lg\\:\\!max-w-\\[270px\\] {
		max-width: 270px !important;
	}

	.lg\\:\\!max-w-\\[330px\\] {
		max-width: 330px !important;
	}

	.lg\\:max-w-\\[145px\\] {
		max-width: 145px;
	}

	.lg\\:max-w-\\[170px\\] {
		max-width: 170px;
	}

	.lg\\:max-w-\\[230px\\] {
		max-width: 230px;
	}

	.lg\\:max-w-\\[250px\\] {
		max-width: 250px;
	}

	.lg\\:max-w-\\[300px\\] {
		max-width: 300px;
	}

	.lg\\:max-w-\\[330px\\] {
		max-width: 330px;
	}

	.lg\\:max-w-\\[475px\\] {
		max-width: 475px;
	}

	.lg\\:max-w-\\[550px\\] {
		max-width: 550px;
	}

	.lg\\:grid-cols-10 {
		grid-template-columns: repeat(10, minmax(0, 1fr));
	}

	.lg\\:grid-cols-3 {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.lg\\:flex-row {
		flex-direction: row;
	}

	.lg\\:items-center {
		align-items: center;
	}

	.lg\\:gap-10 {
		gap: 2.5rem;
	}

	.lg\\:gap-12 {
		gap: 3rem;
	}

	.lg\\:gap-14 {
		gap: 3.5rem;
	}

	.lg\\:gap-20 {
		gap: 5rem;
	}

	.lg\\:gap-3 {
		gap: 0.75rem;
	}

	.lg\\:gap-4 {
		gap: 1rem;
	}

	.lg\\:gap-5 {
		gap: 1.25rem;
	}

	.lg\\:gap-6 {
		gap: 1.5rem;
	}

	.lg\\:gap-7 {
		gap: 1.75rem;
	}

	.lg\\:gap-8 {
		gap: 2rem;
	}

	.lg\\:gap-x-6 {
		column-gap: 1.5rem;
	}

	.lg\\:gap-y-5 {
		row-gap: 1.25rem;
	}

	.lg\\:space-y-5 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
	}

	.lg\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
	}

	.lg\\:p-4 {
		padding: 1rem;
	}

	.lg\\:p-5 {
		padding: 1.25rem;
	}

	.lg\\:p-6 {
		padding: 1.5rem;
	}

	.lg\\:px-10 {
		padding-left: 2.5rem;
		padding-right: 2.5rem;
	}

	.lg\\:px-16 {
		padding-left: 4rem;
		padding-right: 4rem;
	}

	.lg\\:px-5 {
		padding-left: 1.25rem;
		padding-right: 1.25rem;
	}

	.lg\\:px-6 {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	}

	.lg\\:py-10 {
		padding-top: 2.5rem;
		padding-bottom: 2.5rem;
	}

	.lg\\:py-6 {
		padding-top: 1.5rem;
		padding-bottom: 1.5rem;
	}

	.lg\\:py-7 {
		padding-top: 1.75rem;
		padding-bottom: 1.75rem;
	}

	.lg\\:py-8 {
		padding-top: 2rem;
		padding-bottom: 2rem;
	}

	.lg\\:pr-8 {
		padding-right: 2rem;
	}

	.lg\\:\\!text-\\[13px\\] {
		font-size: 13px !important;
	}

	.lg\\:text-\\[13\\.5px\\] {
		font-size: 13.5px;
	}

	.lg\\:text-lg {
		font-size: 1.125rem;
		line-height: 1.75rem;
	}

	.lg\\:text-sm {
		font-size: 0.875rem;
		line-height: 1.25rem;
	}

	.lg\\:text-xl {
		font-size: 1.25rem;
		line-height: 1.75rem;
	}
}

@media (min-width: 1280px) {

	.xl\\:left-\\[200px\\] {
		left: 200px;
	}

	.xl\\:col-span-5 {
		grid-column: span 5 / span 5;
	}

	.xl\\:h-\\[100px\\] {
		height: 100px;
	}

	.xl\\:h-\\[110px\\] {
		height: 110px;
	}

	.xl\\:h-\\[125px\\] {
		height: 125px;
	}

	.xl\\:h-\\[21px\\] {
		height: 21px;
	}

	.xl\\:h-\\[90px\\] {
		height: 90px;
	}

	.xl\\:w-11\\/12 {
		width: 91.666667%;
	}

	.xl\\:w-2\\/6 {
		width: 33.333333%;
	}

	.xl\\:w-4\\/6 {
		width: 66.666667%;
	}

	.xl\\:w-\\[200px\\] {
		width: 200px;
	}

	.xl\\:w-\\[calc\\(100\\%-200px\\)\\] {
		width: calc(100% - 200px);
	}

	.xl\\:max-w-\\[240px\\] {
		max-width: 240px;
	}

	.xl\\:max-w-\\[600px\\] {
		max-width: 600px;
	}

	.xl\\:grid-cols-3 {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.xl\\:grid-cols-5 {
		grid-template-columns: repeat(5, minmax(0, 1fr));
	}

	.xl\\:gap-12 {
		gap: 3rem;
	}

	.xl\\:gap-4 {
		gap: 1rem;
	}

	.xl\\:gap-5 {
		gap: 1.25rem;
	}

	.xl\\:gap-6 {
		gap: 1.5rem;
	}

	.xl\\:px-20 {
		padding-left: 5rem;
		padding-right: 5rem;
	}

	.xl\\:text-\\[11\\.5px\\] {
		font-size: 11.5px;
	}

	.xl\\:text-\\[12\\.5px\\] {
		font-size: 12.5px;
	}

	.xl\\:text-sm {
		font-size: 0.875rem;
		line-height: 1.25rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/index.css","<no source>"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,wBAAwB;CACxB,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;;;;;;;CAQC,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;;AAEA;;CAEC,wBAAwB;CACxB,SAAS;AACV;AACA;CACC,qBAAqB;CACrB,0BAA0B;AAC3B;;AAEA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;CAAA,wBAAc;CAAd,wBAAc;CAAd,mBAAc;CAAd,mBAAc;CAAd,cAAc;CAAd,cAAc;CAAd,cAAc;CAAd,eAAc;CAAd,eAAc;CAAd,aAAc;CAAd,aAAc;CAAd,kBAAc;CAAd,sCAAc;CAAd,8BAAc;CAAd,6BAAc;CAAd,4BAAc;CAAd,eAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,kBAAc;CAAd,2BAAc;CAAd,4BAAc;CAAd,sCAAc;CAAd,kCAAc;CAAd,2BAAc;CAAd,sBAAc;CAAd,8BAAc;CAAd,YAAc;CAAd,kBAAc;CAAd,gBAAc;CAAd,iBAAc;CAAd,kBAAc;CAAd,cAAc;CAAd,gBAAc;CAAd,aAAc;CAAd,mBAAc;CAAd,qBAAc;CAAd,2BAAc;CAAd,yBAAc;CAAd,0BAAc;CAAd,2BAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,yBAAc;CAAd;AAAc;;AAAd;CAAA,wBAAc;CAAd,wBAAc;CAAd,mBAAc;CAAd,mBAAc;CAAd,cAAc;CAAd,cAAc;CAAd,cAAc;CAAd,eAAc;CAAd,eAAc;CAAd,aAAc;CAAd,aAAc;CAAd,kBAAc;CAAd,sCAAc;CAAd,8BAAc;CAAd,6BAAc;CAAd,4BAAc;CAAd,eAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,kBAAc;CAAd,2BAAc;CAAd,4BAAc;CAAd,sCAAc;CAAd,kCAAc;CAAd,2BAAc;CAAd,sBAAc;CAAd,8BAAc;CAAd,YAAc;CAAd,kBAAc;CAAd,gBAAc;CAAd,iBAAc;CAAd,kBAAc;CAAd,cAAc;CAAd,gBAAc;CAAd,aAAc;CAAd,mBAAc;CAAd,qBAAc;CAAd,2BAAc;CAAd,yBAAc;CAAd,0BAAc;CAAd,2BAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,yBAAc;CAAd;AAAc;AAEd;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,uDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,2DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,gEAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,+DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,gEAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,8DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,gEAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,+DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,gEAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,4DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,+DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,8DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,4DAAmB;CAAnB;AAAmB;AAAnB;CAAA,wBAAmB;CAAnB,kEAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB,uBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,+BAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,iCAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,iCAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,+BAAmB;CAAnB;AAAmB;AAAnB;CAAA,+BAAmB;CAAnB;AAAmB;AAAnB;CAAA,+BAAmB;CAAnB;AAAmB;AAAnB;CAAA,+BAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,+EAAmB;CAAnB,mGAAmB;CAAnB;AAAmB;AAAnB;CAAA,6EAAmB;CAAnB,iGAAmB;CAAnB;AAAmB;AAAnB;CAAA,8BAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,4DAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,6BAAmB;CAAnB,+QAAmB;SAAnB;AAAmB;AAAnB;CAAA,+QAAmB;SAAnB;AAAmB;AAAnB;CAAA,gKAAmB;CAAnB,wJAAmB;CAAnB,iLAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA,wBAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA,+FAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA,+BAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA,8BAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;;AAEnB;CACC,2BAA2B;CAC3B,4CAAyC;AAC1C;AACA;CACC,0BAA0B;CAC1B,4CAAwC;AACzC;AACA;CACC,wBAAwB;CACxB,4CAAsC;AACvC;AACA;CACC;;;;EAIC;CACD,kCAA0B;SAA1B,0BAA0B;AAC3B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD;AACA;CACC,uCAAuC;AACxC;AACA;CACC,sCAAsC;AACvC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,kCAAkC;AACnC;AACA;CACC,kEAAkE;AACnE;AACA;CACC;;;;EAIC;AACF;AACA;CACC,gCAAgC;AACjC;AACA;CACC;;;;EAIC;AACF;AACA;CACC,sCAAsC;AACvC;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,kDAAkD;AACnD;AACA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,UAAU;CACV,aAAa;AACd;AACA;CACC;EACC,cAAc;CACf;AACD;;AAEA,UAAU;AACV;CACC,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA,WAAW;AACX;CACC,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA,oBAAoB;AACpB;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,SAAS,EAAE,iCAAiC;CAC5C,SAAS;CACT,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;CACnB,yDAAyD;AAC1D;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;;CAEC,6BAA6B;CAC7B,WAAW;CACX,iBAAiB;CACjB,oCAAoC;CACpC,sBAAsB;CACtB,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;;CAEC,0BAA0B;CAC1B,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,6CAA6C;CAC7C,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;CAC5B,sBAAsB;CACtB,iCAAiC;CACjC,mCAAmC;CACnC,yBAAyB;AAC1B;;AAEA;CACC;EACC,cAAc;EACd,qBAAqB;CACtB;;CAEA;EACC,UAAU;EACV,iBAAiB;CAClB;;CAEA;EACC,cAAc;EACd,qBAAqB;CACtB;AACD;;AA5PA;CAAA;CCAA;;ADAA;CAAA;CCAA;;ADAA;CAAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA;CCAA;;ADAA;CAAA,mBCAA;CDAA,mBCAA;CDAA;CCAA;;ADAA;CAAA,oBCAA;CDAA,oBCAA;CDAA;CCAA;;ADAA;CAAA;CCAA;;ADAA;CAAA,uBCAA;CDAA;CCAA;;ADAA;CAAA,uBCAA;CDAA;CCAA;;ADAA;CAAA;CCAA;;ADAA;CAAA,mBCAA;CDAA;CCAA;;ADAA;CAAA,mBCAA;CDAA;CCAA;;ADAA;CAAA,mBCAA;CDAA;CCAA;;ADAA;CAAA,mBCAA;CDAA;CCAA;;ADAA;CAAA,mBCAA;CDAA;CCAA;;ADAA;CAAA,sBCAA;CDAA;CCAA;;ADAA;CAAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA,qBCAA;CDAA;CCAA;;ADAA;CAAA;CCAA;;ADAA;CAAA;CCAA;;ADAA;CAAA,kCCAA;CDAA;CCAA;;ADAA;CAAA,uBCAA;CDAA;CCAA;;ADAA;CAAA,uBCAA;CDAA;CCAA;;ADAA;;CAAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,iBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,gECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,iECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,gECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,+DCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,sBCAA;EDAA;ECAA;;CDAA;EAAA,uBCAA;EDAA;ECAA;;CDAA;EAAA,sBCAA;EDAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,kBCAA;EDAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,kBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,gBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;CAAA;;ADAA;;CAAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,iBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,gECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,iECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,+DCAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,iECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,gECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,iECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,6DCAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,gECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,+DCAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,gECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,6DCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,uBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,sBCAA;EDAA;ECAA;;CDAA;EAAA,uBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,sBCAA;EDAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,sBCAA;EDAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,gBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;CAAA;;ADAA;;CAAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,gECAA;EDAA;ECAA;;CDAA;EAAA,wBCAA;EDAA,+DCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA,sBCAA;EDAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,qBCAA;EDAA;ECAA;;CDAA;EAAA,kBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;CAAA;;ADAA;;CAAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,mBCAA;EDAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA;ECAA;;CDAA;EAAA,oBCAA;EDAA;ECAA;CAAA","sourcesContent":["* {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\nbody {\n\tletter-spacing: 0.25px;\n\tbackground: #fff;\n\t-ms-overflow-style: none;\n\tfont-family: \"ZabalRegular\";\n}\n\na {\n\ttext-decoration: none;\n}\n\n.MuiInputBase-root,\n.MuiOutlinedInput-root,\n.MuiInputBase-colorPrimary,\n.MuiInputBase-fullWidth,\n.MuiInputBase-formControl,\n.MuiInputBase-adornedEnd,\n.MuiAutocomplete-inputRoot,\n.css-ct26vv-MuiInputBase-root-MuiOutlinedInput-root {\n\tborder-radius: 8px !important;\n}\n\n.swiper {\n\tborder-radius: 12px;\n}\n\ninput {\n\tfont-size: 16px;\n}\ninput::placeholder {\n\tfont-size: 14px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n\t-webkit-appearance: none;\n\tmargin: 0;\n}\ninput[type=\"number\"] {\n\tappearance: textfield;\n\t-moz-appearance: textfield;\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n\tfont-family: \"ZabalRegular\";\n\tsrc: url(../public/ZabalDEMO-Regular.otf);\n}\n@font-face {\n\tfont-family: \"ZabalMedium\";\n\tsrc: url(../public/ZabalDEMO-Medium.otf);\n}\n@font-face {\n\tfont-family: \"ZabalBold\";\n\tsrc: url(../public/ZabalDEMO-Bold.otf);\n}\n.logoBg {\n\tbackground: linear-gradient(\n\t\t180deg,\n\t\t#476569 -291.25%,\n\t\trgba(254, 254, 254, 0) 100%\n\t);\n\tbackdrop-filter: blur(4px);\n}\n\ninput:focus {\n\toutline: none;\n}\n\n.lInput {\n\tbackground: rgba(113, 126, 131, 0.7);\n}\n\n@media screen and (min-width: 600px) {\n\t.lInput {\n\t\tbackground: transparent;\n\t}\n}\n.zabalRegFont {\n\tfont-family: \"ZabalRegular\", sans-serif;\n}\n.zabalMedFont {\n\tfont-family: \"ZabalMedium\", sans-serif;\n}\n.zabalBoldFont {\n\tfont-family: \"ZabalBold\", sans-serif;\n}\n.chillaxFont {\n\tfont-family: \"Chillax\", sans-serif;\n}\n.activeLink {\n\tbackground: linear-gradient(90deg, #ffffff 19.02%, #ffffff00 183%);\n}\n.blueGradient {\n\tbackground: linear-gradient(\n\t\t0deg,\n\t\t#eff8f9 -33.24%,\n\t\trgba(239, 248, 249, 0) 123.74%\n\t);\n}\n.bigSelectOpen {\n\tbox-shadow: 0px 4px 16px #eef2f3;\n}\n.bigSelectOpen .innerCard:hover {\n\tbackground: linear-gradient(\n\t\t0deg,\n\t\t#eff8f9 -33.24%,\n\t\trgba(239, 248, 249, 0) 123.74%\n\t);\n}\n.indexBalance {\n\tbox-shadow: 2px 2px 12px 0px #5d65661f;\n}\n.transactCard:first-of-type {\n\tfilter: drop-shadow(0px 4px 16px #eef2f3);\n}\n.payment:hover {\n\tbox-shadow: 0px 4px 12px rgba(126, 126, 126, 0.08);\n}\n.scroll-wrapper {\n\tpadding-bottom: 0.2rem;\n\toverflow-x: auto;\n\tscrollbar-width: thin;\n}\n.scroll-wrapper::-webkit-scrollbar {\n\theight: 6px;\n\twidth: 6px;\n\tdisplay: none;\n}\n@media (min-width: 640px) {\n\t.scroll-wrapper::-webkit-scrollbar {\n\t\tdisplay: block;\n\t}\n}\n\n/* Track */\n.scroll-wrapper::-webkit-scrollbar-track {\n\tbackground: #8c30f512;\n\tborder-radius: 10px;\n}\n\n/* Handle */\n.scroll-wrapper::-webkit-scrollbar-thumb {\n\tbackground: gainsboro;\n\tborder-radius: 10px;\n}\n\n/* Handle on hover */\n.scroll-wrapper::-webkit-scrollbar-thumb:hover {\n\tbackground: #b4b1b8;\n}\n\n.tooltip:hover .tooltiptext {\n\tvisibility: visible;\n}\n\n.tooltip .tooltiptext::after {\n\tcontent: \" \";\n\tposition: absolute;\n\ttop: 100%; /* At the bottom of the tooltip */\n\tleft: 50%;\n\tmargin-left: -5px;\n\tborder-width: 5px;\n\tborder-style: solid;\n\tborder-color: #00525d transparent transparent transparent;\n}\n\n.carousel-root {\n\twidth: 100%;\n}\n\nli.slide {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.swiper-button-next,\n.swiper-button-prev {\n\tposition: absolute !important;\n\tz-index: 15;\n\tbackground: white;\n\tbox-shadow: 0px 1px 20px 0px #b8c8cf;\n\twidth: 30px !important;\n\theight: 30px !important;\n\tborder-radius: 9999px;\n}\n\n.swiper-button-next::after,\n.swiper-button-prev::after {\n\tfont-size: 12px !important;\n\tcolor: #003a50 !important;\n\tfont-weight: bolder;\n}\n\n.swiper-button-prev {\n\tleft: -5px !important;\n}\n\n.swiper-button-next {\n\tright: -2px !important;\n}\n\n.loginBtnLoading {\n\twidth: 48px;\n\theight: 48px;\n\tborder-radius: 999px;\n\tbackground: #8e9da4;\n\ttransition: all linear 0.2s;\n}\n\n.loginBtn {\n\twidth: 100%;\n\theight: 45px;\n\tborder-radius: 8px;\n\tbackground: #00525d;\n\t/* transition: borderRadius linear 0.5s 2s; */\n\ttransition: all linear 0.5s;\n}\n\n.blink {\n\tanimation-name: viewBtnBlink;\n\tanimation-duration: 2s;\n\tanimation-timing-function: linear;\n\tanimation-iteration-count: infinite;\n\tanimation-fill-mode: both;\n}\n\n@keyframes viewBtnBlink {\n\t0% {\n\t\tcolor: #00525d;\n\t\tborder-color: #00525d;\n\t}\n\n\t50% {\n\t\tcolor: red;\n\t\tborder-color: red;\n\t}\n\n\t100% {\n\t\tcolor: #00525d;\n\t\tborder-color: #00525d;\n\t}\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
